module.exports = __webpack_public_path__ + "img/wa-line4.8600f42.png";